import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 pt-20">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10 py-16">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            页面未找到
          </h1>
          <p className="mt-2 text-sm text-foreground-400">{location.pathname}</p>
          <p className="mt-4 text-sm text-foreground-500">
            抱歉，您访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-line"></i>返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}